import {
  TCompanyGroupsRRMEntry,
  THeaderScore,
  TRRMDisplayEntry,
  TRRMListEntry,
} from "../services/types/user.types";

export function mapRRMListToDisplay(
  entries: TRRMListEntry[] | undefined | null
): TRRMDisplayEntry[] {
  if (!entries?.length) return [];
  return entries.map((item) => ({
    id: item.id,
    rrmseq: item.rrmseq,
    color: item.color,
    desc: item.desc,
    title: item.title,
    anliza: item.anliza,
    recommendations: item.recommendations,
    highlights: item.highlights,
    conversation: item.conversation,
    statusId: item.statusId,
    rangeStart: null,
    rangeEnd: null,
  }));
}

export function mapCompanyGroupsRRMToDisplay(
  entries: TCompanyGroupsRRMEntry[] | undefined | null
): TRRMDisplayEntry[] {
  if (!entries?.length) return [];
  return [...entries]
    .sort((a, b) => a.Seq - b.Seq)
    .map((item) => ({
      id: item.Id,
      rrmseq: item.Seq,
      color: item.Color,
      desc: item.Desc,
      title: item.Title,
      anliza: item.Anliza,
      recommendations: item.Recommendations,
      highlights: item.Highlights,
      conversation: item.Conversation,
      statusId: item.StatusId,
      rangeStart: item.Start,
      rangeEnd: item.End,
    }));
}

export function findBandForScore(
  score: number,
  bands: TRRMDisplayEntry[]
): TRRMDisplayEntry | undefined {
  if (!bands.length) return undefined;
  const matched = bands.find(
    (band) =>
      band.rangeStart != null &&
      band.rangeEnd != null &&
      score >= band.rangeStart &&
      score <= band.rangeEnd
  );
  return matched ?? bands[bands.length - 1];
}

export function hasHeaderScoresWithBands(
  scores?: THeaderScore[] | null
): boolean {
  return !!scores?.some((h) => h.CompanyGroupsRRM?.length);
}
